import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { Icons, ROLE_IDS } from './models/constants';
import { AuthGuard } from './guards/auth.guard';
import {
  orderHistoryFlagGuard,
  patientProfileFlagGuard,
} from './guards/patient-view-flag.guard';
import { ErrorComponent } from './pages/error/error.component';

export const RoutePaths = {
  Overview: {
    Path: 'overview',
    Title: 'route.overview',
    Icon: Icons.Overview,
    AllowedRoles: [
      ROLE_IDS.PHARMACY_ADMINISTRATOR,
      ROLE_IDS.PHARMACY_MANAGER,
      ROLE_IDS.PHARMACY_USER,
    ],
  },
  RequestAcknowledgedList: {
    Path: 'request-acknowledged-list',
    Title: 'route.request-acknowledged',
    Icon: Icons.RequestAcknowledgedList,
    AllowedRoles: [
      ROLE_IDS.PHARMACY_ADMINISTRATOR,
      ROLE_IDS.PHARMACY_MANAGER,
      ROLE_IDS.PHARMACY_USER,
    ],
  },
  FollowUpList: {
    Path: 'follow-up-list',
    Title: 'route.follow-up',
    Icon: Icons.FollowUpList,
    AllowedRoles: [
      ROLE_IDS.PHARMACY_ADMINISTRATOR,
      ROLE_IDS.PHARMACY_MANAGER,
      ROLE_IDS.PHARMACY_USER,
    ],
  },
  OrderVerificationList: {
    Path: 'order-verification-list',
    Title: 'route.order-verification',
    Icon: Icons.OrderVerificationList,
    AllowedRoles: [
      ROLE_IDS.PHARMACY_ADMINISTRATOR,
      ROLE_IDS.PHARMACY_MANAGER,
      ROLE_IDS.PHARMACY_USER,
    ],
  },
  ReadyToShipList: {
    Path: 'ready-to-ship-list',
    Title: 'route.ready-to-ship',
    Icon: Icons.ReadyToShipList,
    AllowedRoles: [
      ROLE_IDS.PHARMACY_ADMINISTRATOR,
      ROLE_IDS.PHARMACY_MANAGER,
      ROLE_IDS.PHARMACY_USER,
    ],
  },
  PendingDeliveryList: {
    Path: 'pending-delivery-list',
    Title: 'route.pending-delivery',
    Icon: Icons.PendingDeliveryList,
    AllowedRoles: [
      ROLE_IDS.PHARMACY_ADMINISTRATOR,
      ROLE_IDS.PHARMACY_MANAGER,
      ROLE_IDS.PHARMACY_USER,
    ],
  },
  PatientPickupList: {
    Path: 'patient-pickup-list',
    Title: 'route.patient-pickup',
    Icon: Icons.PatientPickupList,
    AllowedRoles: [
      ROLE_IDS.PHARMACY_ADMINISTRATOR,
      ROLE_IDS.PHARMACY_MANAGER,
      ROLE_IDS.PHARMACY_USER,
    ],
  },
  CompletedDeliveryList: {
    Path: 'completed-delivery-list',
    Title: 'route.completed-delivery',
    Icon: Icons.CompletedDeliveryList,
    AllowedRoles: [
      ROLE_IDS.PHARMACY_ADMINISTRATOR,
      ROLE_IDS.PHARMACY_MANAGER,
      ROLE_IDS.PHARMACY_USER,
    ],
  },
  CommercializationList: {
    Path: 'commercialization-list',
    Title: 'route.commercialization',
    Icon: Icons.CommercializationList,
    AllowedRoles: [
      ROLE_IDS.PHARMACY_ADMINISTRATOR,
      ROLE_IDS.PHARMACY_MANAGER,
      ROLE_IDS.PHARMACY_USER,
    ],
  },
  CommercializationStatus: {
    Path: 'commercialization-status/:patientId/:workflowId',
    Title: 'route.commercialization-status',
    Icon: Icons.CommercializationList,
    AllowedRoles: [
      ROLE_IDS.PHARMACY_ADMINISTRATOR,
      ROLE_IDS.PHARMACY_MANAGER,
      ROLE_IDS.PHARMACY_USER,
    ],
  },
  ArList: {
    Path: 'ar-list',
    Title: 'route.ar-list',
    Icon: Icons.ArList,
    AllowedRoles: [
      ROLE_IDS.PHARMACY_ADMINISTRATOR,
      ROLE_IDS.PHARMACY_MANAGER,
      ROLE_IDS.PHARMACY_USER,
    ],
  },
  TestBillList: {
    Path: 'test-bill-list',
    Title: 'route.test-bill',
    Icon: Icons.TestBillList,
    AllowedRoles: [
      ROLE_IDS.PHARMACY_ADMINISTRATOR,
      ROLE_IDS.PHARMACY_MANAGER,
      ROLE_IDS.PHARMACY_USER,
    ],
  },
  UserList: {
    Path: 'user-list',
    Title: 'route.user-list',
    Icon: Icons.UserList,
    AllowedRoles: [ROLE_IDS.PHARMACY_ADMINISTRATOR, ROLE_IDS.PHARMACY_MANAGER],
  },
  UserDetailsWithParams: {
    Path: 'user-details/:id',
    Title: 'route.user-details',
    Icon: Icons.UserDetails,
    AllowedRoles: [ROLE_IDS.PHARMACY_ADMINISTRATOR, ROLE_IDS.PHARMACY_MANAGER],
  },
  UserDetailsWithoutParams: {
    Path: 'user-details',
    Title: 'route.user-details',
    Icon: Icons.UserDetails,
    AllowedRoles: [ROLE_IDS.PHARMACY_ADMINISTRATOR, ROLE_IDS.PHARMACY_MANAGER],
  },
  PharmacyList: {
    Path: 'pharmacy-list',
    Title: 'route.pharmacy-list',
    Icon: Icons.PharmacyList,
    AllowedRoles: [ROLE_IDS.PHARMACY_ADMINISTRATOR, ROLE_IDS.PHARMACY_MANAGER],
  },
  WorkflowList: {
    Path: 'workflow-list',
    Title: 'route.workflow-list',
    Icon: Icons.WorkflowList,
    AllowedRoles: [ROLE_IDS.PHARMACY_ADMINISTRATOR],
  },
  WorkflowDetails: {
    Path: 'workflow-details/:id',
    Title: 'route.workflow-details',
    Icon: Icons.PharmacyDetails,
    AllowedRoles: [ROLE_IDS.PHARMACY_ADMINISTRATOR, ROLE_IDS.PHARMACY_MANAGER],
  },
  WorkflowDetailsWithoutParams: {
    Path: 'workflow-details',
    Title: 'route.workflow-details',
    Icon: Icons.WorkflowDetails,
    AllowedRoles: [ROLE_IDS.PHARMACY_ADMINISTRATOR, ROLE_IDS.PHARMACY_MANAGER],
  },
  PharmacyCreateUpdate: {
    Path: 'pharmacy-create-update/:id',
    Title: 'route.pharmacy-create-update',
    Icon: Icons.PharmacyDetails,
    AllowedRoles: [ROLE_IDS.PHARMACY_ADMINISTRATOR, ROLE_IDS.PHARMACY_MANAGER],
  },
  Sandbox: {
    Path: 'sandbox',
    Title: 'route.sandbox',
    Icon: Icons.Sandbox,
    AllowedRoles: [ROLE_IDS.ADMINISTRATOR],
  },
  FeatureFlags: {
    Path: 'feature-flags',
    Title: 'route.feature-flags',
    Icon: Icons.FeatureFlags,
    AllowedRoles: [ROLE_IDS.ADMINISTRATOR],
  },
  MasterDrugList: {
    Path: 'master-drug-list',
    Title: 'route.master-drug-list',
    Icon: Icons.DrugList,
    AllowedRoles: [ROLE_IDS.PHARMACY_ADMINISTRATOR, ROLE_IDS.PHARMACY_MANAGER],
  },
  OrderDetails: {
    Path: 'order-details/:id',
    Title: 'route.order-details',
    Icon: Icons.RequestAcknowledgedList,
    AllowedRoles: [
      ROLE_IDS.PHARMACY_ADMINISTRATOR,
      ROLE_IDS.PHARMACY_MANAGER,
      ROLE_IDS.PHARMACY_USER,
    ],
  },
  PatientOrderCreate: {
    Path: 'patient-order-create',
    Title: 'route.patient-order-create',
    Icon: Icons.PharmacyDetails,
    AllowedRoles: [
      ROLE_IDS.PHARMACY_ADMINISTRATOR,
      ROLE_IDS.PHARMACY_MANAGER,
      ROLE_IDS.PHARMACY_USER,
    ],
  },
  OrderStatus: {
    Path: 'order-status/:id',
    Title: 'route.order-status',
    Icon: Icons.RequestAcknowledgedList,
    AllowedRoles: [
      ROLE_IDS.PHARMACY_ADMINISTRATOR,
      ROLE_IDS.PHARMACY_MANAGER,
      ROLE_IDS.PHARMACY_USER,
    ],
  },
  PatientSearch: {
    Path: 'patient-search',
    Title: 'route.patient-search',
    Icon: Icons.PatientSearch,
    AllowedRoles: [
      ROLE_IDS.PHARMACY_ADMINISTRATOR,
      ROLE_IDS.PHARMACY_MANAGER,
      ROLE_IDS.PHARMACY_USER,
    ],
  },
  DriverScheduleList: {
    Path: 'driver-schedule-list',
    Title: 'route.driver-schedule-list',
    Icon: Icons.DriverScheduleList,
    AllowedRoles: [
      ROLE_IDS.PHARMACY_ADMINISTRATOR,
      ROLE_IDS.PHARMACY_MANAGER,
      ROLE_IDS.PHARMACY_USER,
      ROLE_IDS.TRANSPORTATION_MANAGER,
    ],
  },
  OrderHistory: {
    Path: 'order-history/:id',
    Title: 'route.order-history',
    Icon: Icons.OrderHistory,
    AllowedRoles: [
      ROLE_IDS.PHARMACY_ADMINISTRATOR,
      ROLE_IDS.PHARMACY_MANAGER,
      ROLE_IDS.PHARMACY_USER,
    ],
  },
  PatientProfile: {
    Path: 'patient-profile/:id',
    Title: 'route.patient-profile',
    Icon: Icons.PatientProfile,
    AllowedRoles: [
      ROLE_IDS.PHARMACY_ADMINISTRATOR,
      ROLE_IDS.PHARMACY_MANAGER,
      ROLE_IDS.PHARMACY_USER,
    ],
  },
  GroupAddressBook: {
    Path: 'address-book',
    Title: 'route.group-address-book',
    Icon: Icons.GroupAddressBook,
    AllowedRoles: [
      ROLE_IDS.PHARMACY_ADMINISTRATOR,
      ROLE_IDS.PHARMACY_MANAGER,
      ROLE_IDS.PHARMACY_USER,
    ],
  },
  OtherDrugList: {
    Path: 'other-drug-list',
    Title: 'route.other-drug-list',
    Icon: Icons.OtherDrugList,
    AllowedRoles: [
      ROLE_IDS.PHARMACY_ADMINISTRATOR,
      ROLE_IDS.PHARMACY_MANAGER,
      ROLE_IDS.PHARMACY_USER,
    ],
  },
  DeliveryIssuesList: {
    Path: 'delivery-issues-list',
    Title: 'route.delivery-issues-list',
    Icon: Icons.DeliveryIssuesList,
    AllowedRoles: [
      ROLE_IDS.PHARMACY_ADMINISTRATOR,
      ROLE_IDS.PHARMACY_MANAGER,
      ROLE_IDS.PHARMACY_USER,
    ],
  },
  DataTools: {
    Path: 'data-tools',
    Title: 'route.data-tools',
    Icon: Icons.DataTools,
    AllowedRoles: [ROLE_IDS.PHARMACY_ADMINISTRATOR],
  },
  DashboardSettings: {
    Path: 'dashboard-settings',
    Title: 'route.dashboard-settings',
    Icon: Icons.DashboardSettings,
    AllowedRoles: [ROLE_IDS.PHARMACY_ADMINISTRATOR],
  },
  ManagerAnalytics: {
    Path: 'manager-analytics',
    Title: 'route.manager-analytics',
    Icon: Icons.ManagerAnalytics,
    AllowedRoles: [ROLE_IDS.PHARMACY_MANAGER, ROLE_IDS.PHARMACY_ADMINISTRATOR],
  },
  MyDay: {
    Path: 'my-day',
    Title: 'route.my-day',
    Icon: Icons.MyDay,
    AllowedRoles: [
      ROLE_IDS.PHARMACY_ADMINISTRATOR,
      ROLE_IDS.PHARMACY_MANAGER,
      ROLE_IDS.PHARMACY_USER,
    ],
  },
  KpiSettings: {
    Path: 'kpi-settings',
    Title: 'route.kpi-settings',
    Icon: Icons.KpiSettings,
    AllowedRoles: [ROLE_IDS.PHARMACY_MANAGER, ROLE_IDS.PHARMACY_ADMINISTRATOR],
  },
  Error: { Path: 'error', Title: 'route.error', Icon: Icons.Error },
};

/**
 * Maps user roles to their default routes.
 */
export const RolesDefaultRoutes = {
  [RoutePaths.MyDay.Path]: [
    ROLE_IDS.PHARMACY_ADMINISTRATOR,
    ROLE_IDS.PHARMACY_MANAGER,
    ROLE_IDS.PHARMACY_USER,
  ],
  [RoutePaths.DriverScheduleList.Path]: [ROLE_IDS.TRANSPORTATION_MANAGER],
};

/**
 * Defines the routes for the application.
 * These routes are used to navigate between pages and components.
 */
export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: RoutePaths.MyDay.Path,
  },
  { path: RoutePaths.Error.Path, component: ErrorComponent },
  {
    path: '',
    // Lazy-loaded on purpose: the shell's navbar/sidenav import RoutePaths from this file, so a
    // static AppShellComponent import here would be a circular module reference (TDZ crash in the
    // Karma bundle). Lazy loading breaks the cycle without changing runtime behavior.
    loadComponent: () =>
      import('./components/app-shell/app-shell.component').then((m) => m.AppShellComponent),
    canActivate: [MsalGuard],
    children: [
      {
        path: RoutePaths.Overview.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.Overview.Title,
          allowedRoles: RoutePaths.Overview.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/overview/overview.component').then(
            (m) => m.OverviewComponent,
          ),
      },
      {
        path: RoutePaths.RequestAcknowledgedList.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.RequestAcknowledgedList.Title,
          allowedRoles: RoutePaths.RequestAcknowledgedList.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/request-acknowledged-list/request-acknowledged-list.component').then(
            (m) => m.RequestAcknowledgedListComponent,
          ),
      },
      {
        path: RoutePaths.FollowUpList.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.FollowUpList.Title,
          allowedRoles: RoutePaths.FollowUpList.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/follow-up-list/follow-up-list.component').then(
            (m) => m.FollowUpListComponent,
          ),
      },
      {
        path: RoutePaths.OrderVerificationList.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.OrderVerificationList.Title,
          allowedRoles: RoutePaths.OrderVerificationList.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/order-verification-list/order-verification-list.component').then(
            (m) => m.OrderVerificationListComponent,
          ),
      },
      {
        path: RoutePaths.ReadyToShipList.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.ReadyToShipList.Title,
          allowedRoles: RoutePaths.ReadyToShipList.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/ready-to-ship-list/ready-to-ship-list.component').then(
            (m) => m.ReadyToShipListComponent,
          ),
      },
      {
        path: RoutePaths.ReadyToShipList.Path,
        canActivate: [AuthGuard],
        data: { title: RoutePaths.ReadyToShipList.Title },
        loadComponent: () =>
          import('./pages/ready-to-ship-list/ready-to-ship-list.component').then(
            (m) => m.ReadyToShipListComponent,
          ),
      },
      {
        path: RoutePaths.PendingDeliveryList.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.PendingDeliveryList.Title,
          allowedRoles: RoutePaths.PendingDeliveryList.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/pending-delivery-list/pending-delivery-list.component').then(
            (m) => m.PendingDeliveryListComponent,
          ),
      },
      {
        path: RoutePaths.PatientPickupList.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.PatientPickupList.Title,
          allowedRoles: RoutePaths.PatientPickupList.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/patient-pickup-list/patient-pickup-list.component').then(
            (m) => m.PatientPickUpListComponent,
          ),
      },
      {
        path: RoutePaths.CompletedDeliveryList.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.CompletedDeliveryList.Title,
          allowedRoles: RoutePaths.CompletedDeliveryList.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/completed-delivery-list/completed-delivery-list.component').then(
            (m) => m.CompletedDeliveryListComponent,
          ),
      },
      {
        path: RoutePaths.CommercializationList.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.CommercializationList.Title,
          allowedRoles: RoutePaths.CommercializationList.AllowedRoles,
          requiresCommercializationAccess: true,
        },
        loadComponent: () =>
          import('./pages/commercialization-list/commercialization-list.component').then(
            (m) => m.CommercializationListComponent,
          ),
      },
      {
        path: RoutePaths.CommercializationStatus.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.CommercializationStatus.Title,
          allowedRoles: RoutePaths.CommercializationStatus.AllowedRoles,
          requiresCommercializationAccess: true,
        },
        loadComponent: () =>
          import('./pages/commercialization-status/commercialization-status.component').then(
            (m) => m.CommercializationStatusComponent,
          ),
      },
      {
        path: RoutePaths.ArList.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.ArList.Title,
          allowedRoles: RoutePaths.ArList.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/ar-list/ar-list.component').then(
            (m) => m.ArListComponent,
          ),
      },
      {
        path: RoutePaths.TestBillList.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.TestBillList.Title,
          allowedRoles: RoutePaths.TestBillList.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/test-bill-list/test-bill-list.component').then(
            (m) => m.TestBillListComponent,
          ),
      },
      {
        path: RoutePaths.UserList.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.UserList.Title,
          allowedRoles: RoutePaths.UserList.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/user/user-list/user-list.component').then(
            (m) => m.UserListComponent,
          ),
      },
      {
        path: RoutePaths.UserDetailsWithParams.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.UserDetailsWithParams.Title,
          allowedRoles: RoutePaths.UserDetailsWithParams.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/user/user-create-update/user-create-update.component').then(
            (m) => m.UserDetailsComponent,
          ),
      },
      {
        path: RoutePaths.UserDetailsWithoutParams.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.UserDetailsWithoutParams.Title,
          allowedRoles: RoutePaths.UserDetailsWithoutParams.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/user/user-create-update/user-create-update.component').then(
            (m) => m.UserDetailsComponent,
          ),
      },
      {
        path: RoutePaths.Sandbox.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.Sandbox.Title,
          allowedRoles: RoutePaths.Sandbox.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/sandbox/sandbox.component').then(
            (m) => m.SandboxComponent,
          ),
      },
      {
        path: RoutePaths.FeatureFlags.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.FeatureFlags.Title,
          allowedRoles: RoutePaths.FeatureFlags.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/feature-flags/feature-flags.component').then(
            (m) => m.FeatureFlagsComponent,
          ),
      },
      {
        path: RoutePaths.PharmacyList.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.PharmacyList.Title,
          allowedRoles: RoutePaths.PharmacyList.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/pharmacy/pharmacy-list/pharmacy-list.component').then(
            (m) => m.PharmacyListComponent,
          ),
      },
      {
        path: RoutePaths.WorkflowList.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.WorkflowList.Title,
          allowedRoles: RoutePaths.WorkflowList.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/workflow/workflow-list/workflow-list.component').then(
            (m) => m.WorkflowListComponent,
          ),
      },
      {
        path: RoutePaths.WorkflowDetails.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.WorkflowDetails.Title,
          allowedRoles: RoutePaths.WorkflowDetails.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/workflow/workflow-create-update/workflow-create-update.component').then(
            (m) => m.WorkflowDetailsComponent,
          ),
      },
      {
        path: RoutePaths.WorkflowDetailsWithoutParams.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.WorkflowDetailsWithoutParams.Title,
          allowedRoles: RoutePaths.WorkflowDetailsWithoutParams.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/workflow/workflow-create-update/workflow-create-update.component').then(
            (m) => m.WorkflowDetailsComponent,
          ),
      },
      {
        path: RoutePaths.WorkflowDetailsWithoutParams.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.WorkflowDetailsWithoutParams.Title,
          allowedRoles: RoutePaths.WorkflowDetailsWithoutParams.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/workflow/workflow-create-update/workflow-create-update.component').then(
            (m) => m.WorkflowDetailsComponent,
          ),
      },
      {
        path: RoutePaths.PharmacyCreateUpdate.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.PharmacyCreateUpdate.Title,
          allowedRoles: RoutePaths.PharmacyCreateUpdate.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/pharmacy/pharmacy-create-update/pharmacy-create-update.component').then(
            (m) => m.PharmacyCreateUpdateComponent,
          ),
      },
      {
        path: RoutePaths.MasterDrugList.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.MasterDrugList.Title,
          allowedRoles: RoutePaths.MasterDrugList.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/master-drug-list/master-drug-list.component').then(
            (m) => m.MasterDrugListComponent,
          ),
      },
      {
        path: RoutePaths.OrderDetails.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.OrderDetails.Title,
          allowedRoles: RoutePaths.OrderDetails.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/order/order-details/order-details.component').then(
            (m) => m.OrderDetailsComponent,
          ),
      },
      {
        path: RoutePaths.PatientOrderCreate.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.PatientOrderCreate.Title,
          allowedRoles: RoutePaths.PatientOrderCreate.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/order/patient-order-create/patient-order-create.component').then(
            (m) => m.PatientOrderCreateComponent,
          ),
      },
      {
        path: RoutePaths.OrderStatus.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.OrderStatus.Title,
          allowedRoles: RoutePaths.OrderStatus.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/order/order-status/order-status.component').then(
            (m) => m.OrderStatusComponent,
          ),
      },
      {
        path: RoutePaths.PatientSearch.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.PatientSearch.Title,
          allowedRoles: RoutePaths.PatientSearch.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/patient-search/patient-search.component').then(
            (m) => m.PatientSearchComponent,
          ),
      },
      {
        path: RoutePaths.DriverScheduleList.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.DriverScheduleList.Title,
          allowedRoles: RoutePaths.DriverScheduleList.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/driver-schedule-list/driver-schedule-list.component').then(
            (m) => m.DriverScheduleListComponent,
          ),
      },
      {
        path: RoutePaths.OrderHistory.Path,
        canActivate: [AuthGuard, orderHistoryFlagGuard],
        data: {
          title: RoutePaths.OrderHistory.Title,
          allowedRoles: RoutePaths.OrderHistory.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/order/order-history/order-history.component').then(
            (m) => m.OrderHistoryComponent,
          ),
      },
      {
        path: RoutePaths.PatientProfile.Path,
        canActivate: [AuthGuard, patientProfileFlagGuard],
        data: {
          title: RoutePaths.PatientProfile.Title,
          allowedRoles: RoutePaths.PatientProfile.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/patient-profile/patient-profile.component').then(
            (m) => m.PatientProfileComponent,
          ),
      },
      {
        path: RoutePaths.GroupAddressBook.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.GroupAddressBook.Title,
          allowedRoles: RoutePaths.GroupAddressBook.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/group-address-book/group-address-book.component').then(
            (m) => m.GroupAddressBookComponent,
          ),
      },
      {
        path: RoutePaths.OtherDrugList.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.OtherDrugList.Title,
          allowedRoles: RoutePaths.OtherDrugList.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/other-drug-list/other-drug-list.component').then(
            (m) => m.OtherDrugListComponent,
          ),
      },
      {
        path: RoutePaths.DeliveryIssuesList.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.DeliveryIssuesList.Title,
          allowedRoles: RoutePaths.DeliveryIssuesList.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/delivery-issues-list/delivery-issues-list.component').then(
            (m) => m.DeliveryIssuesListComponent,
          ),
      },
      {
        path: RoutePaths.DataTools.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.DataTools.Title,
          allowedRoles: RoutePaths.DataTools.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/data-tools/data-tools.component').then(
            (m) => m.DataToolsComponent,
          ),
      },
      {
        path: RoutePaths.DashboardSettings.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.DashboardSettings.Title,
          allowedRoles: RoutePaths.DashboardSettings.AllowedRoles,
        },
        loadComponent: () =>
          import('./pages/dashboard-settings/dashboard-settings.component').then(
            (m) => m.DashboardSettingsComponent,
          ),
      },
      {
        path: RoutePaths.ManagerAnalytics.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.ManagerAnalytics.Title,
          allowedRoles: RoutePaths.ManagerAnalytics.AllowedRoles,
          feature: 'managerAnalytics',
        },
        loadComponent: () =>
          import('./pages/manager-analytics/manager-analytics.component').then(
            (m) => m.ManagerAnalyticsComponent,
          ),
      },
      {
        path: RoutePaths.MyDay.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.MyDay.Title,
          allowedRoles: RoutePaths.MyDay.AllowedRoles,
          feature: 'gamification',
        },
        loadComponent: () =>
          import('./pages/my-day/my-day.component').then(
            (m) => m.MyDayComponent,
          ),
      },
      {
        path: RoutePaths.KpiSettings.Path,
        canActivate: [AuthGuard],
        data: {
          title: RoutePaths.KpiSettings.Title,
          allowedRoles: RoutePaths.KpiSettings.AllowedRoles,
          feature: 'gamification',
        },
        loadComponent: () =>
          import('./pages/kpi-settings/kpi-settings.component').then(
            (m) => m.KpiSettingsComponent,
          ),
      },
      {
        path: '**',
        loadComponent: () =>
          import('./pages/page-not-found/page-not-found.component').then(
            (m) => m.PageNotFoundComponent,
          ),
      },
    ],
  },
];
